/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Signin1Inputs */

const he_auth_signup_signin1 = /** @type {(inputs: Auth_Signup_Signin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`להתחברות`)
};

const en_auth_signup_signin1 = /** @type {(inputs: Auth_Signup_Signin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Auth_Signup_Signin1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_signup_signin1 = /** @type {((inputs?: Auth_Signup_Signin1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Signin1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_signup_signin1(inputs)
	return en_auth_signup_signin1(inputs)
});
export { auth_signup_signin1 as "auth_signup_signIn" }